export default __webpack_public_path__ + "static/media/background.5c3fd8a8.svg";